import { useCallback } from 'react';

import {
   ActionBar,
   ButtonVariant,
   useHistoryPushWithBackAction,
   useLocationWithBackState,
} from '@dreryk/react-components';

import { patientPaths } from '~libs.desktop.shared.paths';

import { usePatientUpdateCommand } from '../PatientConfirmedUpdatePanel/PatientConfirmedUpdatePersonalData/PatientConfirmedUpdateAction';
import { patientTranslationKeys } from '../translations';

import { PatientUnconfirmedFormController } from './patientUnconfirmedUpdate.types';

type PatientUnconfirmedUpdateActionProps = {
   readonly patientId: number;
   readonly handleSubmit: PatientUnconfirmedFormController['handleSubmit'];
   readonly onSuccess: VoidFunction;
};
export const PatientUnconfirmedUpdateAction = (props: PatientUnconfirmedUpdateActionProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(false);
   const location = useLocationWithBackState();
   const handlePatientUpdateSuccess = useCallback(() => {
      props.onSuccess();
      push(patientPaths.getDataPath(props.patientId), {
         label: location?.state.label ?? patientTranslationKeys.goBackToPatientList,
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [push, props.patientId, props.onSuccess]);
   const { executeAsync: updatePatient } = usePatientUpdateCommand(props.patientId, null, handlePatientUpdateSuccess);
   return (
      <ActionBar.PrimaryButton
         testId={'unconfirmedPatientUpdate'}
         label={patientTranslationKeys.unconfirmed.save}
         variant={ButtonVariant.PRIMARY}
         onClick={props.handleSubmit(updatePatient)}
         order={1}
         blockingOperation
      />
   );
};
